import { Component, ElementRef, EventEmitter, Input, Output, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { api } from 'src/app/properties/endpoints';
import Hls from 'hls.js';
import { DigitalSopService } from 'src/app/services/digital-sop.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import videojs from 'video.js';
import 'videojs-markers';
import { QuillEditorComponent } from 'ngx-quill';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-digital-sop-form-molecule',
  templateUrl: './digital-sop-form-molecule.component.html',
  styleUrls: ['./digital-sop-form-molecule.component.scss']
})
export class DigitalSopFormMoleculeComponent {
  @ViewChildren('quillEditor') quillEditors!: QueryList<QuillEditorComponent>;
  @ViewChild('target') target!: ElementRef;
  @Input() formData;
  @Output() sopUpdated = new EventEmitter<string>();
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @ViewChild('suggestionDialog') suggestionDialog!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  sopDetailsForm: FormGroup;
  sopStepForm: FormGroup;
  isCreatingNewSop: boolean = false;
  stream: string;
  createdSopDetails: any;
  isProcessing: boolean = false;
  enableSave: boolean = false;
  currentSop: any;
  player: any;
  markers = [];
  pollingInterval: any;
  hlsVideo:any;
  sopSteps: any[] = [];
  aiSuggestions: { [index: number]: string[] } = {};
  svgIcon = `<img src="data:image/svg+xml;utf8,
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' fill='green' width='20' height='20'>
    <path d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v112H80c-17.7 0-32 14.3-32 32s14.3 32 
    32 32h112v112c0 17.7 14.3 32 32 32s32-14.3 
    32-32V256h112c17.7 0 32-14.3 
    32-32s-14.3-32-32-32H256V80z'/>
  </svg>" style="width: 20px; height: 20px; display: inline-block;" />`
  editorModules = {
    toolbar: {
      container: '#custom-toolbar',
    }
  };
  dialogData = {
    originalText: '',
    stepIndex: 0,
    suggestions: [],
    loading: true
  };
  // uploading:boolean = false;
  // fetchingImage:boolean = false; 
  uploadingSteps: boolean[] = [];
  fetchingImageSteps: boolean[] = [];

  imageUrl: string | null = null;
  stepImages: { [index: number]: string } = {};

  constructor(private fb: FormBuilder, private digitalSopService: DigitalSopService,
    private snack: MatSnackBar, private sanitizer: DomSanitizer, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.initForm();
    this.sopStepForm.valueChanges.subscribe(() => {
      this.checkIfFormDirty();
    });
    this.sopDetailsForm.valueChanges
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((formValue) => {
        if (this.sopDetailsForm.valid) {
          this.triggerUpdateApi(formValue);
        }
      });
    if (this.formData != null && Object.keys(this.formData).length > 0) {
      this.isCreatingNewSop = true;
      this.fetchSop(this.formData.id);
    } else if (this.formData && Object.keys(this.formData).length === 0) {
      this.formData = null;
      this.createNewSop();
    }
  }
  get fullVideoUrl(): string {
    return `${api.host}${this.formData?.hlsPath}`;
  }
  insertSVG(svgContent: string, stepIndex: number) {
    const editorComponent = this.quillEditors.toArray()[stepIndex];
    const editor = editorComponent.quillEditor;

    const range = editor.getSelection(true);
    // if (range) {
    //   // Insert the emoji wrapped in a span or paragraph tag
    //   editor.clipboard.dangerouslyPasteHTML(range.index, `<span>${svgContent}</span>`);
    //   editor.setSelection(range.index + svgContent.length, 0);
    // }
    if (range) {
      // const imgTag = `<img src="${svgContent}" style="width: 20px;">`;
      // const encoded = encodeURIComponent(svgContent);
      // const dataUri = `data:image/svg+xml;utf8,${encoded}`;
      // const imgTag = `<img src="${dataUri}" style="width:20px; height:20px;" />`;

      editor.clipboard.dangerouslyPasteHTML(range.index, svgContent);
      const updatedHTML = editor.root.innerHTML;
      this.steps.at(stepIndex).get('instructions')?.setValue(updatedHTML);
      editor.setSelection(range.index + svgContent.length, 0);

    }
    this.enableSave = true;
  }
  checkIfFormDirty(): void {
    this.enableSave = this.steps.controls.some(stepGroup => stepGroup.dirty);
  }


  fetchSop(id) {
    this.digitalSopService.getSopById(id).subscribe((res: any) => {
      this.currentSop = res;
      if (res.videoProcessing === 'IN-PROGRESS') {
        if (!this.pollingInterval) {
          this.pollingInterval = setInterval(() => {
            this.fetchSop(id); // Recursive polling
          }, 10000);
        }
        return;
      }
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
        this.sopUpdated.emit(this.currentSop.id);
      }
      this.sopSteps = [];
      this.stepImages = [];
      if (res.steps?.length > 0) {
        this.sopSteps = res?.steps;
        // this.sopSteps.forEach(step => this.addStepToForm(step));
        this.sopSteps.forEach((step, i) => {
          if (step.imageUrl) {
            this.fetchingImageSteps[i] = true;
            this.getStepImage(i, step.imageUrl);
          }
          this.addStepToForm(step)
        });
      }
    })
  }
  private initForm() {
    this.sopDetailsForm = this.fb.group({
      name: [this.formData?.name || '', Validators.required],
      partNo: [this.formData?.partNo || '', Validators.required],
      station: [this.formData?.station || '', Validators.required],
    });
    this.sopStepForm = this.fb.group({
      steps: this.fb.array([])
    });

    this.sopSteps.forEach(step => this.addStepToForm(step));
  }
  get steps(): FormArray {
    return this.sopStepForm.get('steps') as FormArray;
  }
  triggerUpdateApi(formValue) {
    const payload = {
      id: this.formData?.id,
      name: formValue.name,
      partNo: formValue.partNo,
      station: formValue.station
    }
    this.digitalSopService.updateSop(payload).subscribe((res: any) => {
      this.showSnackbar('Fields updated successfully');
      this.sopUpdated.emit(payload.id);
    })
  }
  addStepToForm(step?: any) {
    const stepGroup = this.fb.group({
      startSeconds: [step?.startSeconds || 0, Validators.required],
      endSeconds: [step?.endSeconds || 0, Validators.required],
      stepName: [step?.stepName || '', Validators.required],
      instructions: [step?.instructions || '', Validators.required]
    });

    this.steps.push(stepGroup);
  }

  createNewSop() {
    this.sopDetailsForm = this.fb.group({
      name: ['', Validators.required],
      partNo: ['', Validators.required],
      station: ['', Validators.required],
    });
    this.isCreatingNewSop = true;
  }
  ngAfterViewInit() {
    if (this.formData?.hlsPath) {
      const video: HTMLVideoElement = this.target?.nativeElement;
      // const path = this.currentSop?.hlsPath ? this.currentSop.hlsPath : this.formData.hlsPath;
      const path = this.currentSop?.hlsPath || this.formData?.hlsPath;
      this.stream = `${api.host}${path}`;
      if (Hls.isSupported()) {
        this.hlsVideo = new Hls();
        this.hlsVideo.loadSource(this.stream);
        this.hlsVideo.attachMedia(video);
        this.hlsVideo.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = this.stream;
        video.addEventListener('loadedmetadata', () => {
          video?.play();
        });
      } else {
        console.error('HLS not supported in this browser.');
      }
      this.player = videojs(video);
      this.player.markers({
        markers: this.markers,
        markerStyle: {
          // width: '24px',
          height: '17px',
          backgroundColor: 'transparent',
          position: 'absolute',
          bottom: '0px',
          content: '',
        },
        markerTip: {
          display: false,
        }
      });
      this.player.ready(() => {
        const progressControl = this.player.controlBar.progressControl.el();
        if (progressControl) {
          progressControl.addEventListener('click', (event: any) => {
            const rect = (event.target as HTMLElement).getBoundingClientRect();
            const clickX = event.clientX - rect.left;
            const width = rect.width;
            const percentage = clickX / width;
            const duration = this.player.duration();
            const clickedTime = duration * percentage;
            this.addMarker(clickedTime);
          });
        }
      });
    }
  }
  addMarker(time: number) {
    const roundedTime = Math.floor(time);
    if (this.markers.find(m => m.time === roundedTime)) {
      this.showSnackbar(`Marker already exists at ${roundedTime}s`);
      return;
    }
    // Prevent inserting in the middle
    const lastMarkerTime = this.markers.length > 0 ? this.markers[this.markers.length - 1].time : 0;
    if (roundedTime <= lastMarkerTime) {
      this.showSnackbar(`Please add marker after the last one at ${lastMarkerTime}s`);
      return;
    }
    const prevStep = this.sopSteps.length > 0 ? this.sopSteps[this.sopSteps.length - 1] : null;
    const newStep: any = {
      stepName: '',
      startSeconds: prevStep ? prevStep.endSeconds : 0,
      endSeconds: roundedTime,
      instructions: ''
    };
    if (newStep.startSeconds >= newStep.endSeconds) {
      this.showSnackbar('Invalid selection.Step start time cannnot be greater than end time.');
      return;
    }
    const stepIndex = this.markers.length + 1;
    this.markers.push({
      time: time,
      text: `Step at ${this.formatTime(time)}`,
      class: `custom-marker marker-${stepIndex}`
    });
    this.player.markers.updateTime();
    this.player.markers.add(this.markers);
    setTimeout(() => {
      const el = document.querySelector(`.marker-${stepIndex}`) as HTMLElement;
      if (el) {
        el.innerHTML = '<span class="material-icons" style="font-size:16px">beenhere</span>';
      }
    }, 100);

    this.sopSteps.push(newStep);
    this.addStepToForm(newStep);
    this.enableSave = true;
  }
  initializeMarkersFromSteps() {
    if (this.sopSteps.length > 0 && this.player) {
      this.markers = [];
      this.player.markers.removeAll();

      this.sopSteps.forEach((step, index) => {
        const stepIndex = index + 1;
        this.markers.push({
          time: step.endSeconds,
          text: `Step at ${this.formatTime(step.endSeconds)}`,
          class: `custom-marker marker-${stepIndex}`
        });
      });
      this.player.markers.updateTime();
      this.player.markers.add(this.markers);

      setTimeout(() => {
        this.markers.forEach((_, index) => {
          const el = document.querySelector(`.marker-${index + 1}`);
          if (el) {
            el.innerHTML = '<span class="material-icons red">beenhere</span>';
          }
        });
      }, 100);
    }

  }

  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  ngOnDestroy(): void {
    if (this.player) {
      this.player.dispose();
    }
  }
  createSop() {
    const payload = {
      name: this.sopDetailsForm.value.name,
      partNo: this.sopDetailsForm.value.partNo,
      station: this.sopDetailsForm.value.station
    }
    this.digitalSopService.createSop(payload).subscribe((response: any) => {
      this.createdSopDetails = response;
    })
  }
  deleteStep(index: number) {
    this.steps.removeAt(index);
    const removedStep = this.sopSteps.splice(index, 1)[0];
    const markerIndex = this.markers.findIndex(m => Math.floor(m.time) === Math.floor(removedStep.endSeconds));
    if (markerIndex !== -1) {
      this.markers.splice(markerIndex, 1);
    }
    if (index > 0 && index < this.sopSteps.length) {
      const prevStep = this.sopSteps[index - 1];
      const nextStep = this.sopSteps[index];
      nextStep.startSeconds = prevStep.endSeconds;
      const nextFormGroup = this.steps.at(index) as FormGroup;
      nextFormGroup.get('startSeconds')?.setValue(prevStep.endSeconds);
    }
    this.player.markers.removeAll();
    this.player.markers.add(this.markers);
    this.enableSave = true;
  }


  onVideoSelected(event: any): void {
    const file = event.target.files[0];
    if (!this.sopDetailsForm.valid) {
      this.showSnackbar("Please fill in the SOP details before uploading the video.");
      return;
    }
    this.isProcessing = true;
    const sopDetailsPayload = {
      name: this.sopDetailsForm.value.name,
      partNo: this.sopDetailsForm.value.partNo,
      station: this.sopDetailsForm.value.station
    }
    if (this.formData != null) {
      const payload = {
        id: this.formData.id,
        file: file
      }
      this.uploadVideo(payload)
    } else {
      this.digitalSopService.createSop(sopDetailsPayload).subscribe((response: any) => {
        this.createdSopDetails = response;
        const payload = {
          id: this.createdSopDetails.id,
          file: file
        }
        this.uploadVideo(payload)
      })
    }
  }
  showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  uploadVideo(payload) {
    this.digitalSopService.updateVideo(payload).subscribe((response: any) => {
      if (response) {
        this.sopUpdated.emit(payload.id);
        this.showSnackbar(`Your video is processing`);
        this.isProcessing = false;
      }
    })
  }
  saveSteps() {
    const invalidStep = this.steps.controls.find(stepControl => {
      return !stepControl.valid;
    });

    if (invalidStep) {
      this.showSnackbar("Please fill in all required fields for each step.");
      return;
    }
    const payload = {
      id: this.formData.id,
      steps: this.steps.value
    };

    this.digitalSopService.updateSteps(payload).subscribe((res: any) => {
      this.showSnackbar("Steps Saved Successfully");
      this.sopUpdated.emit(payload.id);
      this.enableSave = false;
    }, (error) => {
      this.showSnackbar("Error while updating steps");
    })
  }
  destroyVideoPlayer() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  
    if (this.hlsVideo) {
      this.hlsVideo.destroy();
      this.hlsVideo = null;
    }
  }
  
  deleteSop(id: any) {
    this.destroyVideoPlayer();
    this.digitalSopService.deleteSop(id).subscribe((response: any) => {
      this.showSnackbar("Digital SOP deleted successfully");
      this.sopUpdated.emit(null);
    }, (error) => {
      this.showSnackbar("Error while deleting SOP")
    })
  }
  async typeSuggestionsSequentially(stepIndex: number, suggestions: any[]) {
    for (let i = 0; i < suggestions.length; i++) {
      suggestions[i].typedText = '';
      await this.simulateTypingAsync(suggestions[i].text, stepIndex, i);
    }
  }

  simulateTypingAsync(fullText: string, stepIndex: number, suggestionIndex: number, speed = 30): Promise<void> {
    return new Promise((resolve) => {
      let i = 0;
      const interval = setInterval(() => {
        if (i >= fullText.length) {
          clearInterval(interval);
          resolve(); // Move to the next suggestion
        } else {
          this.dialogData.suggestions[suggestionIndex].typedText += fullText.charAt(i);
          i++;
        }
      }, speed);
    });
  }

  fetchAISuggestions(index: number) {
    this.aiSuggestions[index] = [];
    const step = this.steps.at(index);
    const inputText = step.get('instructions')?.value;

    if (!inputText?.trim()) return;
    this.dialogData = {
      originalText: inputText,
      stepIndex: index,
      suggestions: [],
      loading: true
    };
    this.dialogRef = this.dialog.open(this.suggestionDialog, {
      width: '800px'
    });
    const payload = {
      "html_instruction": inputText,
      "variation_count": 3
    }
    this.digitalSopService.fetchSuggestions(payload).subscribe((response: any) => {
      if (response.variations.length === 0) {
        this.menuTrigger.closeMenu();
        this.showSnackbar('No suggestions.Please try again later');
      }
      const cleanedSuggestions = response.variations.map((variation: any) => ({
        ...variation,
        // text: this.stripQuotes(variation.text)
        text: this.sanitizeSvgDataUrl(this.stripQuotes(variation.text)),
        typedText: ''
      }));
      this.aiSuggestions[index] = cleanedSuggestions;
      this.dialogData.suggestions = cleanedSuggestions;
      this.dialogData.loading = false;
      this.typeSuggestionsSequentially(index, cleanedSuggestions);
    }, (error) => {
      this.showSnackbar('Error while fetching suggestions.Please try again later');
      this.aiSuggestions[index] = null;
      this.dialogData.suggestions = [];
      this.dialogData.loading = false;
      this.dialogRef.close();
    })
  }
  sanitizeSvgDataUrl(text: string) {
    return text.replace(/data:image\/svg\+xml;utf8,([\s\S]*?<\/svg>)/g, (match, svg) => {
      const encodedSvg = encodeURIComponent(svg);
      return `data:image/svg+xml;utf8,${encodedSvg}`;
    });
  }

  stripQuotes(text: string): string {
    if (!text) return text;
    try {
      return JSON.parse(text);
    } catch {
      if (text.startsWith('"') && text.endsWith('"')) {
        return text.substring(1, text.length - 1);
      }
      return text;
    }
  }
  sanitizeHTML(html: string): SafeHtml {
    const cleaned = html.replace(/\\"/g, '"');
    return this.sanitizer.bypassSecurityTrustHtml(cleaned);
  }
  applySuggestion(suggestion: string, index: number) {
    this.steps.at(index).patchValue({ instructions: suggestion['text'] || suggestion });
    this.aiSuggestions[index] = [];
    this.dialogData.suggestions = [];
    this.enableSave = true;
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
  onFileSelected(event: any, index: any, isChangeClick: boolean) {
    const file = event.target.files[0];
    if (file) {
      if (isChangeClick) {
        this.stepImages[index] = null;
      }
      this.uploadingSteps[index] = true;
      const formData = new FormData();
      formData.append('image', file);
      const payload = {
        id: this.formData.id,
        index: index + 1,
        file: formData
      };
      this.digitalSopService.addImage(payload).subscribe({
        next: (res: any) => {
          this.uploadingSteps[index] = false;
          this.fetchingImageSteps[index] = true;
          const url = res?.steps[index].imageUrl;
          this.getStepImage(index, url);
        },
        error: () => {
          this.showSnackbar("Failed to upload")
          this.uploadingSteps[index] = false;
        }
      });
    }
  }
  getStepImage(index: any, imageUrl: any) {
    // const imageUrl = updatedSop.steps[index]?.imageUrl;
    if (!imageUrl) return;
    this.digitalSopService.getImage(imageUrl).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.stepImages[index] = objectUrl;
        this.fetchingImageSteps[index] = false;
      },
      error: (err) => {
        this.fetchingImageSteps[index] = false;
        console.error('Image fetch error:', err);
        this.showSnackbar("Error while fetching image")
      }
    })
  }
}
